import {
	get,
} from 'lodash';
import qs from 'qs';
import {HTTPClient} from 'modules/utils/Api';
import {IFetchEventsPayload} from 'modules/actions/dashboard';

const APIClient = new HTTPClient({
	baseURL: process.env.REACT_APP_API_URL || '',
	withCredentials: true,
	transformRequest: [data => qs.stringify(data)],
	onCatchNetworkError: response => get(response, 'response.data')
});

const JSONClientTrivia = new HTTPClient({
	baseURL: process.env.REACT_APP_JSON_TRIVIA_URL || ''
});

const JSONClientPP = new HTTPClient({
	baseURL: process.env.REACT_APP_JSON_PP_URL || ''
});

const JSONClient = new HTTPClient({
	baseURL: process.env.REACT_APP_JSON_URL || ''
});

const TERMS_FILE_NAME = 'terms.json';


export const PlayHubApi = {
	Dashboard: {
		events: (params: IFetchEventsPayload) => APIClient.get('dashboard/events', params),
		stats: () => APIClient.get('dashboard/stats'),
		stats_details: () => APIClient.get('dashboard/stats_details'),
	},
	MGM: {
		cards: () => APIClient.get('cards')
	},
	Ladder: {
		snippet: ({type, ...params}: any) => APIClient.get(`leaderboard_snippet/${type}`, params),
	},
	JSON: {
		mgm_cards: () => JSONClient.get('mgm_cards.json'),
		ad_slot: () => JSONClient.get('ad_slot.json'),
		terms_trivia: () => JSONClientTrivia.get(TERMS_FILE_NAME),
		contests_timezones: () => JSONClientTrivia.get('contests_timezones.json'),
		terms_pp: () => JSONClientPP.get(TERMS_FILE_NAME),
	}
};

